module.exports = __webpack_public_path__ + "apple_macbook12_icon.svg?ab902c15878935687fedea21f4fa4761";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/apple_macbook12_icon.svg
// module id = 215
// module chunks = 0